exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-release-badge{height:.875rem;display:inline-flex;padding:0 .25rem;border-radius:.125rem;background-color:var(--fts-dark);color:var(--fts-light);text-transform:uppercase;font-weight:400;font-style:normal;font-size:.625rem;line-height:.875rem;white-space:normal}.fts-release-badge.release-badge--primary{background-color:var(--fts-primary)}.fts-release-badge.editor-tool-rb{position:absolute;top:-3px;right:0}", ""]);

// exports
